import React, { useState, useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import { BASE_URL } from '../../config';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import ModalDetails from "./ModalDetails";
import ChatDetails from "./ChatDetails";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Cancel_Orders() {
    const [data, setData] = useState([]);
    const MySwal = withReactContent(Swal)
    const [showModal, setShowModal] = useState(false);
    const [idRowSelected, setIdRowSelected] = useState(null);
    const [showChat, setShowChat] = useState(false);
    const previousDataRef = useRef([]);

    let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)
    const fetchData = () => {
        fetchWrapper()
            .doGet({
                url: "/orders_cancel_admin",
                onSuccess: async (response) => {
                    // const newOrders = response.data.orders.filter(order => order.isNew);
                    setData(response.data.orders);
    
                    // if (newOrders.length > 0) {
                    //     newOrders.forEach(order => {
                    //         toast.info(`Nueva orden ID: ${order.id}`);
                    //         markOrdersAsNotNew(order.id);
                    //     });
                    //     
                        
                    // }
                },
                onError: (response) => {
                    alert(response.data.message);
                },
            })
            .catch((error) => {
                console.error(error);
            });
    }
    const markOrdersAsNotNew = (orders) => {
        // Llamar a un endpoint en tu backend para marcar las órdenes como no nuevas
        // Esto debe hacerse en el backend para garantizar la consistencia de los datos
        fetchWrapper()
            .doPost({
                url: "/mark_orders_not_new",
                body: {
                    order_ids: orders
                },
                onSuccess: async (response) => {
                    // Hacer algo después de marcar las órdenes como no nuevas
                },
                onError: (response) => {
                    console.error(response.data.message);
                },
            })
            .catch((error) => {
                console.error(error);
            });
    }

    useEffect(() => {
        fetchData();
    }, []);


    const CustomImage = ({ row }) => (
        <div>
            <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
                src={BASE_URL + row.avatar_url.replace("frontend/public", "static") ?? null} />
        </div>
    );
    const handleOrderStateChange = (id, newState) => {
        var state = newState;
        var orderId = id;
        const actionUrl = newState === 'finish' ? '/api/v1/finish_order' : '/api/v1/cancel_order';
        MySwal.fire({
            title: `¿Está seguro de que desea ${state === 'finish' ? 'finalizar' : 'cancelar'} esta orden? (${orderId})`,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
                    .doPost({
                        url: actionUrl,
                        body:{
                            orderId: orderId,
                            state: state,
                        },
                        onSuccess: async (response) => {
                            fetchData();
                            Swal.fire(
                                'Confirmado!',
                                `La orden ${id} ha sido ${state === 'finish' ? 'finalizada' : 'cancelada'}.`,
                                'success'
                            );
                        },
                        onError: (response) => {
                            console.error(response.data.message);
                            Swal.fire(
                                'Error!',
                                response.data.message,
                                'error'
                            );
                        },
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        });
    };
    const handleActiveCheckboxChange = (event) => {
        var idCheck = event.target.value;
        MySwal.fire({
            title: <p>Esta seguro de cambiar este estado</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            onOpen: () => {

            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/is_paid_for_seifrei",
              body:{
                  order_id: idCheck
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
                // axios({
                //     method: "post",
                //     url: BASE_URL + "/is_paid_for_seifrei",
                //     data: {
                //         order_id: idCheck
                //     },
                //     headers: {
                //         'Authorization': token
                //     },
                //     timeout: 5000,
                // })
                //     .then(
                //         function (response) {
                //             if (response.data.status == 200) {
                //                 fetchData()
                //                 Swal.fire(
                //                     'Confirmado!',
                //                     'Se ha cambiado el estado.',
                //                     'success'
                //                 )
                //             }
                //         }.bind(this)
                //     )
                //     .catch(function (error) {
                //         if (error.response) {
                //             console.log(error.message);
                //             // console.log(response.data.message);
                //             alert(response.data.message);
                //         } else if (error.request) {
                //             alert("Error de conexion");
                //         } else {
                //             // console.log(error.message);
                //             alert(error.message);
                //         }
                //     });


            }
        });
    }

    const editModal = (id) => {
        setIdRowSelected(id)
        setShowModal(true)
    }

    const editChat = (id) => {
        setIdRowSelected(id)
        setShowChat(true)
    }

    const columns = [
        {
            name: "ID",
            selector: "id",
            sortable: true,
        },
        {
            name: "Dirección",
            selector: "address",
            sortable: true,
            wrap: true,
            grow: 3,
        },
        {
            name: "Fecha",
            selector: "date",
            sortable: true,
            grow: 3,
        },
        {
            name: "Total",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.total)}</>,
            sortable: true,
        },
        {
            name: "SubTotal",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.subtotal)}</>,
            sortable: true,
        },
        {
            name: "Despacho",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.dispatch_price)}</>,
            sortable: true,
        },
        {
            name: "Descuento",
            selector: "discount",
            sortable: true,
        },
        {
            name: "Codigo de Descuento",
            selector: 'discount_code',
            sortable: true,
            grow: 3,
        },
        {
            name: "Estado",
            selector: "state",
            sortable: true,
            wrap: true,
            grow: 2,
        },
        {
            name: "Cliente",
            selector: "client",
            sortable: true,
            wrap: true,
        },
        {
            name: "Email Cliente",
            selector: "client_email",
            sortable: true,
            wrap: true,
            grow: 3,
        },
        {
            name: "Cleaner",
            selector: "employee",
            sortable: true,
            wrap: true,
        },
        {
            name: "Email Cleaner",
            selector: "employee_email",
            sortable: true,
            wrap: true,
            grow: 3,
        },
        {
            name: "Rut del Cleaner",
            selector: "employee_rut",
            sortable: true,
            wrap: true,
            grow: 1,
        },
        {
            name: 'Ver detalle',
            cell: row => <a onClick={() => editModal(row.id)}><i class="fas fa-eye"></i></a>,
        },
        {
            name: 'Ver chat',
            cell: row => <a onClick={() => editChat(row.id)}><i class="fas fa-eye"></i></a>,
        },
        {
            name: 'Acciones',
            cell: row => (
                <div>
                    <button 
                        className="btn btn-success"
                        style={{ fontSize: '13px' }}
                        onClick={() => handleOrderStateChange(row.id, 'finish')}
                    >
                        Finalizar
                    </button>
                    <button 
                        className="btn btn-danger"
                        style={{ fontSize: '13px' }}
                        onClick={() => handleOrderStateChange(row.id, 'canceled')}
                    >
                        Cancelar
                    </button>
                </div>
            ),
            grow: 3,
        },
    ];

    const tableData = {
        columns,
        data
    };

    return (
        <>

            <ModalDetails
                showModal={showModal}
                setShowModal={setShowModal}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
            />
            <ChatDetails
                showModal={showChat}
                setShowModal={setShowChat}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
                data={data}
            />

            <div className="row mt-5 mb-5">
                <div className="col-md-10">
                    <h3>Ordenes de compra</h3>
                </div>
                {/* <div className="col-md-2">
                    <button style={{float: "right", marginRight: "20px"}} className="btn btn-primary mr-3"
                            onClick={() => setShowModal(true)}> Nuevo
                    </button>
                </div> */}
            </div>

            <DataTableExtensions {...tableData}>
                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    noHeader
                    paginationPerPage={10}
                />
            </DataTableExtensions>
            <ToastContainer
                position="top-right"
                autoClose={10000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}
